module.exports = __webpack_public_path__ + "static/procesProdukcjaMobile@x1-a2ac3c21fe232f3b03289bf7304ad982.png";